import legacyClientInfo from "./legacyClientInfoPT.json";

export const orderDetails = {
	legacyClientInfo,
};
